import { defer } from '@FLAVOR/src/utils/async-store';
import { css, html, PropertyValues } from 'lit';
import { customElement, property, state } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';
// import { getYearText } from '../components/helpers/years'

const yearText = defer<(year: string) => string, any>('getYearText');

@customElement('purchase-year-popup')
export class PurchaseYearPopup extends DeviceAwareComponent {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        #art {
          width: 66%;
          height: 30rem;
        background-image: url(./assets/year-bought-popup.svg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .title{
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
        color: var(--c-text);
      }
      .message{
        font-weight: var(--font-weight-emphasize);
        color: var(--c-text-sec);
      }
    `,
    ];
  };

  @property()
    value: string = '';

  @state()
    yearText: string = '';

  connectedCallback() {
    super.connectedCallback();
    import(/* webpackChunkName: 'years' */ '../components/helpers/years')
      .then(({ getYearText }) => yearText.resolve(getYearText));
  }

  updated(p: PropertyValues<this>) {
    super.updated(p);
    if (p.has('value')) {
      yearText.then(convert => {
        this.yearText = convert(this.value);
      });
    }
  }

  render() {
    const year = this.value.slice(0, 4);
    return html`
      <div id="art"></div>
      <h2 class="title">${year}</h2>
      <p class="message">${this.yearText}</p>
    `;
  }
}
